module.exports = __webpack_public_path__ + "img/logo404.a95a274c.svg";